var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isSGM && _vm.isSGM.length
    ? _c(
        "span",
        { staticClass: "market-sgp-tag" },
        _vm._l(_vm.isSGM, function(pt) {
          return _c("span", {
            staticClass: "sgp-tag",
            class: [pt, { isForCoupon: _vm.isForCoupon }]
          })
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c8c3c7c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c8c3c7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/common/marketSgpTag.vue
// module id = null
// module chunks = 